export const MRS = 'mrs'
export const MR = 'mr'
export const ND = 'n/d'

export const SALUTATIONS_MAP = {
    [MRS]: MRS,
    [MR]: MR
}
